import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Nav from "./components/Nav";
import Hero from "./components/Hero";
import MeeraSeries from "./components/MeeraSeries";
import PlayfulWorld from "./components/PlayfulWorld";
import Bookshelf from "./components/Bookshelf";
import Articles from "./components/Articles";
import PublicWork from "./components/PublicWork";
import Music from "./components/Music";
import About from "./components/About";
import Journey from "./components/Journey";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import StudioHub from "./pages/StudioHub";
import KolamStudio from "./pages/KolamStudio";
import WarliStudio from "./pages/WarliStudio";
import RangoliStudio from "./pages/RangoliStudio";
import MandalaStudio from "./pages/MandalaStudio";

function HomePage() {
  return (
    <div className="paper-grain relative">
      <Nav />
      <main className="relative z-10">
        <Hero />
        <MeeraSeries />
        <PlayfulWorld />
        <Bookshelf />
        <Articles />
        <PublicWork />
        <Music />
        <About />
        <Journey />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1E2A4F",
            color: "#F9F6F0",
            border: "1px solid #1E2A4F",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/studio" element={<StudioHub />} />
          <Route path="/studio/kolam" element={<KolamStudio />} />
          <Route path="/studio/warli" element={<WarliStudio />} />
          <Route path="/studio/rangoli" element={<RangoliStudio />} />
          <Route path="/studio/mandala" element={<MandalaStudio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
